<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-logo">
        <a href="/">
          <img :src="logoUrl" alt="Ibomstore" />
        </a>
      </div>

      <div class="auth-card">
        <div class="auth-header">
          <h1>Welcome Back</h1>
          <p>Login to your account to continue shopping</p>
        </div>

        <form @submit.prevent="handleLogin" class="auth-form">
          <div class="form-group">
            <label>Email Address *</label>
            <input
              v-model="form.email"
              type="email"
              placeholder="Enter your email"
              required
            >
            <span v-if="errors.email" class="error">{{ Array.isArray(errors.email) ? errors.email[0] : errors.email }}</span>
          </div>

          <div class="form-group">
            <label>Password *</label>
            <div class="password-input-wrapper">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="Enter your password"
                required
              >
              <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <span v-if="errors.password" class="error">{{ errors.password }}</span>
          </div>

          <div class="form-options">
            <label class="checkbox">
              <input type="checkbox" v-model="form.remember" />
              <span>Remember me</span>
            </label>
          </div>

          <button type="submit" class="btn-submit" :disabled="loading">
            {{ loading ? 'Logging in...' : 'Login' }}
          </button>

          <GoogleLoginButton
            mode="login"
            button-text="Continue with Google"
            loading-text="Signing in..."
            @success="onGoogleSuccess"
            @error="onGoogleError"
            @loading="onGoogleLoading"
          />
        </form>

        <div class="auth-footer">
          <p>Don't have an account?
            <a href="/register">Sign up</a>
          </p>
          <a href="/password/forgot" class="forgot-link">Forgot Password?</a>
        </div>

        <div v-if="successMessage" class="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>

        <div v-if="errorMessage" class="rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleLoginButton from '../../components/auth/GoogleLoginButton.vue'

export default {
  name: 'Login',
  components: {
    GoogleLoginButton
  },
  data() {
    return {
      logoUrl: '/logos/logodark.svg',
      form: {
        email: '',
        password: '',
        remember: false
      },
      showPassword: false,
      errors: {},
      loading: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  methods: {
    validateForm() {
      this.errors = {}

      if (!this.form.email) {
        this.errors.email = 'Email is required'
      } else if (!/\S+@\S+\.\S+/.test(this.form.email)) {
        this.errors.email = 'Email is invalid'
      }

      if (!this.form.password) {
        this.errors.password = 'Password is required'
      } else if (this.form.password.length < 6) {
        this.errors.password = 'Password must be at least 6 characters'
      }

      return Object.keys(this.errors).length === 0
    },

    async handleLogin() {
      if (!this.validateForm()) return

      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

        const response = await fetch('/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify(this.form)
        })

        const data = await response.json()

        if (response.ok) {
          this.successMessage = 'Login successful! Redirecting...'
          setTimeout(() => {
            window.location.href = data.redirect || '/'
          }, 500)
        } else {
          if (data.errors) {
            this.errors = data.errors
          }
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.'
      } finally {
        this.loading = false
      }
    },

    onGoogleSuccess(message) {
      this.successMessage = message
    },

    onGoogleError(message) {
      this.errorMessage = message
    },

    onGoogleLoading(isLoading) {
      this.loading = isLoading
    }
  }
}
</script>

